<div *ngIf="!subTour" class="fixed z-40	 bottom-5 cursor-pointer" [ngClass]="rtl?'right-5':'left-5'" (click)="activateTour()">
    <img src="/assets/img/guided-tour.svg" alt="Fixed Icon" />
</div>
<!-- <div *ngIf="subTour" class=" cursor-pointer" (click)="activateTour()">
    <i class="fa-regular fa-question text-zen text-xs"></i>
</div> -->
<div *ngIf="subTour" class="cursor-pointer" (click)="activateTour()">
    <img src="/assets/img/guided-tour.svg" alt="Fixed Icon" class="h-6 w-6" />
</div>
